import Image from 'next/image'
import React from 'react'

import { CommaIcon } from '../assets/Icon'

type FeedBackCardTypes = {
  name: string
  content: string
  profile_url: string
  designation: string
}

const FeedBackCard = (props: FeedBackCardTypes) => {
  const { name, profile_url, content, designation } = props

  return (
    <div className="w-full sm:w-80 rounded-lg bg-white/30 p-7 flex flex-col gap-5 text-zinc-50">
      <div className="flex flex-row gap-1">
        <CommaIcon />
        <CommaIcon />
      </div>
      <div>
        <p className="text-zinc-50">{content}</p>
      </div>
      <div className="flex flex-row gap-3 items-center">
        <div className="overflow-hidden">
          <Image
            src={profile_url}
            alt={''}
            width={70}
            height={70}
            className="rounded-full"
          />
        </div>
        <div className="flex flex-col">
          <p className="font-semibold text-lg">{name}</p>
          <p className="text-gray-50">{designation}</p>
        </div>
      </div>
    </div>
  )
}

export default FeedBackCard
